import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricSearchBudgetLostImpressionShareRateGhaPPA extends MetricBase {
    constructor() {
        super({
            field: "metric_search_budget_lost_impression_share",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads_ppa.searchBudgetLostImpressionShareRate.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads_ppa.searchBudgetLostImpressionShareRate.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads_ppa.searchBudgetLostImpressionShareRate.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricSearchBudgetLostImpressionShareRateGhaPPA;
